import ToggleableSection from 'components/ToggleableSection'
import { withContext } from '../Context'
import NeighborhoodIncomeSelector from './NeighborhoodIncomeSelector'
import FirstGenSelector from '../FirstGenSelector'

export const DemographicsSelector = () => {
  return (
    <ToggleableSection title="Demographics">
      <NeighborhoodIncomeSelector />
      <FirstGenSelector />
    </ToggleableSection>
  )
}

export default withContext(DemographicsSelector)
